const initualState = {
  currentBalance: null,
  transactionDetails: { input: { from: new Date(), to: new Date() }, contributions: [] }
};

export default (state = initualState, action) => {
  switch (action.type) {
    case "SET_CURRENT_BALANCE_VALUES":
      return { ...state, currentBalance: action.payload };
    case "SET_TRANSACTION_DETAILS_VALUES":
      return { ...state, transactionDetails: action.payload };
    default:
      return state;
  }
};
